import { FC, Fragment, useEffect } from 'react';
import { Redirect, Route, Switch, useHistory } from 'react-router-dom';
import RouteConstants from '../router/RouteConstants';
import { CampaignsV2 } from './v2/CampaignsV2';

const LegacyWhatsappCreateRedirect = () => {
  const history = useHistory();

  useEffect(() => {
    history.replace(RouteConstants.createCampaignWhatsapp);
  }, [history]);

  return null;
};

/** Nested routes use plain Route: Layout.routes already wraps CampaignsRouter in PrivateRoute.
 * Re-wrapping with PrivateRoute remounts on every render and resets inbox list state. */
export const CampaignsRouter: FC = () => (
  <Fragment>
    <Switch>
      <Route
        exact
        path={RouteConstants.campaigns}
        component={() => {
          return <Redirect to={RouteConstants.whatsappCampaigns} />;
        }}
      />
      <Route exact path={RouteConstants.createCampaignWhatsappLegacy} component={LegacyWhatsappCreateRedirect} />
      <Route exact path={`${RouteConstants.campaigns}/:tab(whatsapp|sms|email)`} component={CampaignsV2} />
      <Route path={`${RouteConstants.campaigns}/whatsapp/campaigns`} component={CampaignsV2} />
      <Route path={`${RouteConstants.campaigns}/whatsapp/templates`} component={CampaignsV2} />
      <Route path={`${RouteConstants.campaigns}/whatsapp/packages`} component={CampaignsV2} />
      <Route path={`${RouteConstants.campaigns}/whatsapp/inbox`} component={CampaignsV2} />
      <Route path={`${RouteConstants.campaigns}/sms`} component={CampaignsV2} />
      <Route path={`${RouteConstants.campaigns}/email`} component={CampaignsV2} />
      <Redirect to={RouteConstants.whatsappCampaigns} />
    </Switch>
  </Fragment>
);
